/* ARÔME Proyecto doble X: desktop-only product scroll purchase helper.
   This NEVER edits the actual Shopify product form, price or quantity.
   It delegates directly to the existing native Add to Cart button.
   Active only when viewport >= 990px, only within the main product region. */
(() => {
  'use strict';
  const desktop = window.matchMedia('(min-width: 990px)');
  if (!desktop.matches) return; // leave all mobile behavior and markup untouched
  const init = () => {
    const root = document.querySelector('body.ar-web-catalog product-info[id^="MainProduct"]');
    if (!root || root.dataset.arDesktopScrollBuy === 'ready') return;
    const nativeBuy = root.querySelector('.product-form__submit');
    const productSection = root.querySelector('.product:not(.product--no-media)');
    const priceSource = root.querySelector('[data-ar-main-price]');
    const titleSource = root.querySelector('.product__title h1');
    const infoScroll = root.querySelector('.product__info-container');
    if (!nativeBuy || !productSection || !priceSource || !titleSource || !infoScroll) return;
    root.dataset.arDesktopScrollBuy = 'ready';
    const bar = document.createElement('aside');
    bar.className = 'ar-web-scroll-buy';
    bar.setAttribute('aria-label','Compra rápida de este perfume');
    bar.hidden = true;
    const details = document.createElement('div');
    details.className = 'ar-web-scroll-buy__details';
    const name = document.createElement('strong');
    name.className = 'ar-web-scroll-buy__name';
    const price = document.createElement('span');
    price.className = 'ar-web-scroll-buy__price';
    details.append(name, price);
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ar-web-scroll-buy__button';
    button.textContent = 'AGREGAR AL CARRITO';
    button.setAttribute('aria-label','Agregar este perfume al carrito');
    button.addEventListener('click', () => {
      if (!desktop.matches || nativeBuy.disabled) return;
      nativeBuy.click();
    });
    bar.append(details,button);
    document.body.appendChild(bar);

    let inView = true;
    const sync = () => {
      name.textContent = titleSource.textContent.trim();
      price.textContent = priceSource.textContent.trim() + ' MXN';
      button.disabled = !!nativeBuy.disabled;
      const rect = productSection.getBoundingClientRect();
      const inside = rect.top < window.innerHeight - 100 && rect.bottom > 210;
      const drawer = document.querySelector('cart-drawer.active');
      const dialog = document.querySelector('dialog[open]');
      bar.hidden = !desktop.matches || !inside || inView || !!drawer || !!dialog;
    };
    const visibility = new IntersectionObserver((entries) => {
      inView = entries[0]?.isIntersecting ?? true;
      sync();
    }, {threshold:0.2, rootMargin:'-136px 0px -8px 0px'});
    visibility.observe(nativeBuy);
    const dynamic = new MutationObserver(sync);
    dynamic.observe(priceSource,{subtree:true,characterData:true,childList:true});
    dynamic.observe(nativeBuy,{attributes:true,attributeFilter:['disabled']});
    window.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',sync,{passive:true});
    infoScroll.addEventListener('scroll',sync,{passive:true});
    desktop.addEventListener('change',sync);
    document.addEventListener('arome:cart-updated',sync);
    document.addEventListener('cart:updated',sync);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
